import React from 'react';

export default function MenuIconForTouch() {
  return (
    <span
      style={{
        position: 'absolute',
        top: '-5px',
        right: '0px',
        width: '20px',
        height: '20px',
        textAlign: 'center',
        borderWidth: '2px',
        backgroundColor: '#323643',
        fontSize: '12px',
      }}
      className="text-warning text-bold border border-secondary rounded-circle"
    >
      M
    </span>
  );
}
